import React, { Component, Fragment } from 'react';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';
import _ from 'lodash';
import { Form, FormGroup, Label } from 'reactstrap';
import classnames from 'classnames';
import copy from 'copy-to-clipboard';

import FieldInputComponent from 'components/FieldInputComponent';
import FieldUploadImage from 'components/FieldUploadImage';
import FieldSelect from 'components/FieldSelect';
import CounterGroup from 'components/CounterGroup';
import Elucidation from 'components/Elucidation';
import AlertMessage from 'components/AlertMessage';
import InputFeedback from 'components/InputFeedback';
import MasterLinkInfoTooltip from 'components/MasterLinkInfoTooltip';
import linkCopy from 'images/link-copy.svg';
import linkGo from 'images/link-go.svg';
import getEnv from 'helpers/getEnv';

const SUBMIT_DELAY = 1000;

const OPTIONS = [getEnv('REACT_APP_BACKEND_URL')];

const AccountSchema = yup.object().shape({
  shortCode: yup
    .string()
    .required("Master link can't be empty")
    .test({
      name: 'shortCode',
      test: value => value == null || value.indexOf(' ') === -1,
      message: 'Master link must not contain a space',
    }),
  title: yup.string(),
  subtitle: yup.string(),
  image: yup.mixed(),
});

class AccountForm extends Component {
  state = {
    isImageLoading: false,
    showAlert: false,
  };

  handleSetImage = e => {
    this.props.spinnerStart();
    e.persist();
    const { setFieldValue } = this.props;
    setFieldValue('image', e.target.files[0]);
  };

  handleCopy = e => {
    e.preventDefault();
    const { values } = this.props;
    // const text = `${values.domain}/${values.shortCode}`;
    const text = `${getEnv('REACT_APP_BACKEND_URL')}/${values.shortCode}`;
    copy(text);
    this.setState({ showAlert: true });
    setTimeout(() => this.setState({ showAlert: false }), 4000);
  };

  renderOption = opt => (
    <option key={opt} value={opt}>
      {opt}
    </option>
  );

  handleCheckbox = v => {
    const { setFieldValue } = this.props;
    setFieldValue('show_general_info', v);
  };

  renderLinkBtn = () => {
    const { values } = this.props;
    return (
      <div className="link-btn">
        <a
          title="Copy to clipboard"
          onClick={this.handleCopy}
          className="link-btn__itm">
          <img src={linkCopy} alt="" />
        </a>
        <a
          title="Open in new tab"
          // href={`${values.domain}/${values.shortCode}`}
          href={`${getEnv('REACT_APP_BACKEND_URL')}/${values.shortCode}`}
          target="blank"
          className="link-btn__itm">
          <img src={linkGo} alt="" />
        </a>
      </div>
    );
  };

  handleFormChangeDebounced = _.debounce(this.props.handleSubmit, SUBMIT_DELAY);

  render() {
    const { isImageLoading, showAlert } = this.state;
    const {
      errors,
      touched,
      className,
      isSubmitting,
      values,
      total_clicks,
      total_views,
      user,
      spinner,
      spinnerStart,
      account,
    } = this.props;
    return (
      <Fragment>
        {showAlert && <AlertMessage text="Your link has been copied to the clipboard" />}
        <Form
          className="content-form m-b-50 m-r-0"
          onChange={this.handleFormChangeDebounced}>
          {/*
            <FormGroup
            className={classnames(className, {
              'animated shake error': !!errors.shortCode,
            })}>
            <div className="form-group__top">
              <Label for="master-link-input" className="form-group__label">
                Your master link
              </Label>
              <div className="form-group__counter">
                <CounterGroup
                  countViews={total_views}
                  countClicks={total_clicks}
                />
              </div>
            </div>
            <div className="form-group__descr">
              <div className="form-group__inner form-input input-border">
                <div className="select-wrap full">
                  <Field
                    disabled="disabled"
                    type="select"
                    name="domain"
                    component={FieldSelect}
                    className="select w-auto"
                    id="master-link-select">
                    {OPTIONS.map(this.renderOption)}
                  </Field>
                </div>
                <div className="form-group-separator" />
                <Field
                  name="shortCode"
                  type="text"
                  id="master-link-input"
                  className="form-input"
                  placeholder="Type short code here"
                  disabled={!user.subscribed}
                />
                {!isSubmitting &&
                values.shortCode &&
                values.shortCode.indexOf(' ') === -1
                  ? this.renderLinkBtn()
                  : null}
              </div>
              <Elucidation symbol="?" text={<MasterLinkInfoTooltip />} />
            </div>
            <InputFeedback error={errors.shortCode} />
          </FormGroup>
          */}
          <div className="switch-block">
            <div className="switch-block__text">
              Show Title and Description on page
            </div>
            <div className="checkbox-switch">
              <Field
                name="show_general_info"
                type="checkbox"
                checked={account.show_general_info}
                onChange={e => this.handleCheckbox(e.target.checked)}
                className="checkbox-switch__input"
                id="show-general-info"
              />
              <label
                htmlFor="show-general-info"
                className="checkbox-switch__label"
              />
            </div>
          </div>
          <Field
            name="title"
            component={FieldInputComponent}
            error={touched.title && errors.title}
            type="text"
            className="m-b-20"
            id="lable-page-title"
            label="Title"
            placeholder="Enter a title for your page"
            helpText="40 characters or less is recommended"
            border={'1px solid red'}
          />
          <Field
            name="subtitle"
            component={FieldInputComponent}
            error={touched.subtitle && errors.subtitle}
            type="text"
            className="m-b-15"
            id="lable-page-subtitle"
            label="Description"
            placeholder="Provide a description"
            helpText="90 characters or less is recommended"
          />
          <div className="upload-img">
            <Field
              name="image"
              component={FieldUploadImage}
              idUploadInput="upload-profile-img"
              isImageLoading={spinner}
              inputClass="upload-img__input"
              labelClass="upload-img__label"
              setFiles={this.handleSetImage}
              label="Upload profile image"
            />
            <ul className="list-styles">
              <li>Image can be any resolution and aspect ratio</li>
              <li>
                For the best experience, use an image with a minimum width of <strong>600px</strong>{' '}
              </li>
              <li>
                Supported formats are <strong>PNG</strong> and <strong>JPG</strong>{' '}
                with a maximum size of <strong>10MB</strong>
              </li>
            </ul>
          </div>
        </Form>
      </Fragment>
    );
  }
}

const accountHandleSubmit = async (
  values,
  { props, setSubmitting, setErrors },
) => {
  await props.handleSubmit(values, setSubmitting, setErrors);
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => ({
    domain: props.domain || OPTIONS[0],
    shortCode: props.shortCode || '',
    title: props.title || '',
    subtitle: props.subtitle || '',
    image: undefined,
  }),
  validationSchema: AccountSchema,
  handleSubmit: accountHandleSubmit,
})(AccountForm);



// WEBPACK FOOTER //
// ./src/components/MainInfo/AccountForm.js